<template>
  <div id="js-header" class="header">
    <div id="js-headerScroll" class="header__wrapper">
      <h1 class="header__title">
        <router-link to="/">
          <img src="../assets/logo/IslandStateMusic.svg" alt="IslandStateMusic" />
        </router-link>
      </h1>
      <TopNavigation />
    </div>
  </div>
</template>

<script>
import TopNavigation from "./TopNavigation.vue";

export default {
  name: "app-header",
  components: {
    TopNavigation
  },
  data() {
    return {
      limitPosition: 500,
      topPosition: 0
    };
  },
  methods: {
    // onScroll() {
    //   var $globalNav = document.getElementById("js-header");
    //   var $hl = $globalNav.getElementsByClassName("header__title")[0];
    //   if (this.limitPosition < window.scrollY) {
    //     // Scrolled
    //     $globalNav.classList.add("header--tiny");
    //     $hl.classList.add("header__title--tiny");
    //   }
    //   if (this.topPosition >= window.scrollY) {
    //     // Not scrolled
    //     $globalNav.classList.remove("header--tiny");
    //     $hl.classList.remove("header__title--tiny");
    //   }
    // }
  }
  // beforeMount() {
  //   window.addEventListener("scroll", this.onScroll);
  // }
};
</script>

<style lang="scss" scoped>
.header {
  position: relative;
  top: 0;
  background-color:#0c0c0c;
  width: 100%;
  opacity: 1;

  &__wrapper {
    display: block;
    overflow: hidden;
    text-align: center;
  }

  &__title {
    max-width: 860px;
    margin: 1.5em auto;
    &--tiny {
      margin: 1em auto 0.5em auto;
      font-size: 1.2em;
      will-change: transform;
      transition: transform 500ms linear;
      img {
        width: 80px !important;
      }
      & + #nav {
        .top-nav {
          background-color: #0c0c0c;
          border-top: none;
          border-bottom: none;
        }
      }
    }
    img {
      width: 180px;
    }
  }

  &--tiny {
    position: fixed;
    top: 0;
    z-index: 999;
    opacity: 0.9;

    will-change: transform;
    transition: transform 500ms linear;
    div {
      .nav {
        border-top: none;
        border-bottom: none;
      }
    }
  }
}

@media screen and (max-width: 480px) {
  .header {
    img {
      width: 80px !important;
    }

    &__title {
      margin: 1em auto;
    }
    .nav {
      display: block;
    }
  }
  // .header {
  //   $base: &;
  //   &__title {
  //     margin: 1.5em auto;
  //   }
  //   &--tiny {
  //     #{$base} {
  //       &__title {
  //         margin: 1em auto;
  //       }
  //     }
  //     .nav {
  //       display: block;
  //     }
  //   }
  // }
}
</style>
